import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { RedirectService } from './redirect.service';
import { UtilService } from 'src/app/core/utilities/util.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  redirectToLogin: boolean;

  constructor(
    public auth: AuthService,
    public router: Router,
    public redirectService: RedirectService,
    public utilService: UtilService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const sessionKey = route.queryParamMap.get('sessionID');
    const url = new URL(window.location.href);
    url.searchParams.delete('sessionID');
    const encodedLocation = encodeURIComponent(url.toString());
    const loginUrlWithReturnUrl = `${environment.loginURL}?retUrl=${encodedLocation}`;
    const userTypesUrlWithReturnUrl = `${environment.userTypesURL}?retUrl=${encodedLocation}&SessionKey=${sessionKey}`;
    if (!this.auth.isAuthenticated()) {
      this.redirectToLogin = true;
      if (sessionKey) {
        return this.redirectService
          .redirect(userTypesUrlWithReturnUrl, '_self')
          .then(() => {
            return false;
          });
      } else {
        return this.redirectService
          .redirect(loginUrlWithReturnUrl, '_self')
          .then(() => {
            return false;
          });
      }
    } else {
      this.redirectToLogin = false;
      if (sessionKey) {
        this.utilService.logoutWithoutNavigatingToLogin();
        return this.redirectService
          .redirect(userTypesUrlWithReturnUrl, '_self')
          .then(() => {
            return false;
          });
      }
    }

    return true;
  }

  goToExternalPage(url: string) {
    window.location.href = url;
  }
}
